import React from "react";
import { BlueMsg, greenMsg, People2 } from "../../assets/images";

type SecondSplashScreenProps = {
  handleNext: () => void;
};
const SecondSplashScreen: React.FC<SecondSplashScreenProps> = ({
  handleNext,
}) => {
  return (
    <div className="flex h-full items-center bg-midGreen justify-center w-full flex-col relative">
      <div className="absolute top-0 left-0 w-[200px] h-[300px] bg-midGreen">
        <img src={greenMsg} alt="" className="object-cover object-center" />
      </div>

      <div className="w-[90%] flex justify-center h-[60%] z-10 pt-6">
        <img
          src={People2}
          alt=""
          className="h-full w-full object-contain object-center border-none"
        />
      </div>
     
      <div className="px-7 h-[40%] font-BRFirma w-full z-10">
        <div className="text-white text-[25px]">Connect with people</div>
        <div className=" w-full">
          <p className="text-[15px] font-medium text-white break-words whitespace-pre-line text-pretty mt-2">
            The town square for the Ecomoto community-lessors and lessees.
          </p>
          <p className="text-[15px] font-medium text-white break-words whitespace-pre-line text-pretty">
            Here, you can socialize, network, and share content (video,
            pictures, infographics, etc.)
          </p>
          <div
            className="items-center mt-3 cursor-pointer bg-white flex justify-center text-center font-Poppins font-medium text-lg w-[335px] h-[50px] text-midGreen rounded-2xl"
            onClick={handleNext}
          >
            Next
          </div>
        </div>
      </div>

      <div className="absolute bottom-[-140px] right-[-50px] w-[200px] h-[300px] bg-midGreen">
        <img src={BlueMsg} alt="" className="object-cover object-center" />
      </div>
    </div>
  );
};

export default SecondSplashScreen;
